(function() {
  'use strict';

  angular
    .module('winegocjacjeWww', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'angular-owl-carousel']);

})();

(function() {
  'use strict';

  angular
      .module('winegocjacjeWww')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .directive('panelCollapse', panelCollapse);

  /** @ngInject */
  function panelCollapse() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/panel-collapse/panel-collapse.html',
      scope: {
          borderTop: '='
      },
      transclude: {
        'title': '?panelCollapseTitle',
        'body': '?panelCollapseBody',
      },
      controller: panelCollapseController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function panelCollapseController() {
      var vm = this;

      vm.opened = false;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .directive('ngRepeatEnd', ngRepeatEnd);

  /** @ngInject */
  function ngRepeatEnd() {
    var directive = {
      restrict: 'A',
      link: function(scope, element, attrs) {
        if (scope.$last) {
          setTimeout(function () {
            scope.$eval(attrs.ngRepeatEnd);
          }, 1);
        }
      }
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .directive('navbarMain', navbarMain);

  /** @ngInject */
  function navbarMain() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbarMain/navbarMain.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($anchorScroll, $scope, $state) {
      var vm = this;
      vm.collapsed = true;
      
      vm.state = $state;

      vm.scrollTo = scrollTo;
      vm.navbarToggle = navbarToggle;

      function scrollTo(id, offset) {
        vm.collapsed = true;
        $('html, body').animate({
          scrollTop: $('#' + id).offset().top + offset
        }, 1000);
      }

      function navbarToggle() {
        vm.collapsed = !vm.collapsed;
      }

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($anchorScroll, $scope, $state) {
      var vm = this;
      vm.collapsed = true;

      vm.state = $state;

      vm.scrollTo = scrollTo;
      vm.navbarToggle = navbarToggle;


      function scrollTo(id, offset) {
        vm.collapsed = true;
        $('html, body').animate({
          scrollTop: $('#' + id).offset().top + offset
        }, 1000);
      }

      function navbarToggle() {
        vm.collapsed = !vm.collapsed;
      }

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .directive('footer', footer);

  /** @ngInject */
  function footer() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      scope: {
          creationDate: '='
      },
      controller: footerController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function footerController($anchorScroll, $scope, $http) {
      var vm = this;
      vm.collapsed = true;

      vm.scrollTo = scrollTo;
      vm.navbarToggle = navbarToggle;

      vm.sendMail = {
        name: '',
        mail: '',
        phone: '',
        message: '',
        submit: submitMail
      }

      vm.subscribe = {
        mail: '',
        submit: subscribeToNewsletter
      }


      function scrollTo(id, offset) {
        vm.collapsed = true;
        $('html, body').animate({
          scrollTop: $('#' + id).offset().top + offset
        }, 1000);
      }

      function navbarToggle() {
        vm.collapsed = !vm.collapsed;
      }

      function submitMail() {
        $http({
            method: 'POST',
            url: 'app/php/mailer.php',
            data: vm.sendMail,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .success( function(data) {
          if ( data.success ) {
            console.log('mail success');
            vm.mailSuccess = true;
          } else {
            console.log('mail error');
          }
        });
      }

      function subscribeToNewsletter() {
        $http({
            method: 'POST',
            url: 'app/php/subscribe.php',
            data: vm.subscribe,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .success( function(data) {
          if ( data.success ) {
            console.log('subscribe success');
            console.log(data);
            vm.subscribeSuccess = true;
          } else {
            console.log('subscribe error');
            console.log(data);
          }
        });
      }

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .directive('event', event);

  /** @ngInject */
  function event() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/event/event.html',
      scope: {
          more: '=',
          img: '='
      },
      transclude: {
        'title': '?eventTitle',
        'date': '?eventDate',
        'body': '?eventBody',
      },
      controller: eventController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function eventController() {
      var vm = this;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .directive('comment', comment);

  /** @ngInject */
  function comment() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/comment/comment.html',
      scope: {
          img: '='
      },
      transclude: {
        'title': '?commentTitle',
        'subtitle': '?commentSubtitle',
        'body': '?commentBody',
      },
      controller: commentController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function commentController() {
      var vm = this;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .directive('banner', banner);

  /** @ngInject */
  function banner() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/banner/banner.html',
      scope: {
          img: '='
      },
      transclude: {
        'title': '?bannerTitle',
        'body': '?bannerBody',
      },
      controller: bannerController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function bannerController() {
      var vm = this;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .controller('trainingController', trainingController);

  /** @ngInject */
  function trainingController(Api) {
    var vm = this;

    Api.get('/publications/prices/')
      .then(function(response) {
        for (var i = 0; i < response.data.prices.length; i++) {
          if (response.data.prices[i].name == 'training') {
            vm.data = response.data.prices[i];
            console.log(vm.data);
          }
        }
      })
    Api.get('/publications/trainingCollapse')
      .then(function(response) {
        vm.collapses = response.data.texts;
      })

  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .controller('surveyController', surveyController);

  /** @ngInject */
  function surveyController(Api) {
    var vm = this;

    Api.get('/publications/prices/')
      .then(function(response) {
        for (var i = 0; i < response.data.prices.length; i++) {
          if (response.data.prices[i].name == 'survey') {
            vm.data = response.data.prices[i]
            console.log(vm.data);
          }
        }
      })
      Api.get('/publications/surveyCollapse')
        .then(function(response) {
          vm.collapses = response.data.texts;
        })

  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .controller('singleEventController', singleEventController);

  /** @ngInject */
  function singleEventController(Api, $stateParams) {
    var vm = this;
    console.log($stateParams);
    Api.get('/publications/event/' + $stateParams.id)
      .then(function(response) {
        vm.data = response.data.events[0];
        console.log(response);
      })
  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .controller('productsController', productsController);

  /** @ngInject */
  function productsController($stateParams, $uibModal) {
    var vm = this;

    vm.scrollTo = scrollTo;
    vm.mailModalOpen = mailModalOpen;

    if ($stateParams.scrollTo) {
      setTimeout(function () {
        vm.scrollTo($stateParams.scrollTo, 0)
      }, 100);
    }

    function mailModalOpen() {
      $uibModal.open({
        templateUrl: 'app/mail-modal/mail-modal.html',
        controller: 'mailModalController',
        controllerAs: 'vm'
      });
    }

    function scrollTo(id, offset) {
      vm.collapsed = true;
      $('html, body').animate({
        scrollTop: $('.' + id).offset().top + offset
      }, 1000);
    }
    /**
     * inViewport jQuery plugin by Roko C.B.
     * http://stackoverflow.com/a/26831113/383904
     * Returns a callback function with an argument holding
     * the current amount of px an element is visible in viewport
     * (The min returned value is 0 (element outside of viewport)
     */
    ;(function($, win) {
        $.fn.inViewport = function(cb) {
            return this.each(function(i,el){
                function visPx(){
                    var elH = $(el).outerHeight(),
                        H = $(win).height(),
                        r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
                    return cb.call(el, Math.max(0, t>0? Math.min(elH, H-t) : (b<H?b:H)));
                } visPx();
                $(win).on("resize scroll", visPx);
            });
        };
    }(jQuery, window));


    $(".animate-pulse").inViewport(function(px){
      if(px) $(this).addClass("animated pulse") ;
    });
    $("ul li").inViewport(function(px){
      if(px) $(this).addClass("animated bounceIn") ;
    });
    $(".animate-wobble").inViewport(function(px){
      if(px) $(this).addClass("animated jello") ;
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($http, Api) {
    var vm = this;

    vm.getArray = getArray;
    vm.carousel = [];
    vm.commentsInit = commentsInit;
    vm.eventsInit = eventsInit;

    Api.get('/publications/commentsMain')
      .then(function(response) {
        if (response.data.comments) {
          for (var i = 0; i < response.data.comments.length; i++) {
            if (response.data.comments[i].main == true) {
              vm.carousel.push(response.data.comments[i]);
            }
          }
        }
      })

    Api.get('/publications/events')
      .then(function(response) {
        vm.events = response.data.events;
        console.log(response);
      })

    $('.main-carousel').owlCarousel({
      loop:true,
      margin:10,
      nav:true,
      autoplay: true,
      autoHeight:false,
      items: 1,
      navText: [ '', '' ],
      navElement: 'div',
      animateOut: 'fadeOut',
      animateIn: 'fadeIn'
    });

    function getArray(num) {
      return new Array(num)
    }

    function commentsInit() {
      $('.comments-carousel').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        autoplay: true,
        autoHeight:false,
        items: 1,
        navText: [ '', '' ],
        navElement: 'div',
        animateOut: 'fadeOut',
        animateIn: 'fadeIn'
      });
    }
    function eventsInit() {
      $('.news-carousel').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        autoHeight:false,
        items: 1,
        navText: [ '', '' ],
        navElement: 'div',
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        responsive: {
          540: {
            items: 2
          },
          1024: {
            items: 3
          }
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .controller('mailModalController', mailModalController);

  /** @ngInject */
  function mailModalController($http, $uibModalInstance) {
    var vm = this;

    vm.sendMail = {
      name: '',
      mail: '',
      phone: '',
      message: '',
      submit: submitMail
    }

    function submitMail() {
      $http({
          method: 'POST',
          url: 'app/php/mailer-amba.php',
          data: vm.sendMail,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .success( function(data) {
        if ( data.success ) {
          console.log('mail success to amba');
          vm.mailSuccess = true;
          setTimeout(function () {
            $uibModalInstance.dismiss('cancel');
          }, 3000);
        } else {
          console.log('mail error');
        }
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .controller('eventsController', eventsController);

  /** @ngInject */
  function eventsController(Api) {
    var vm = this;

    Api.get('/publications/events')
      .then(function(response) {
        vm.events = response.data.events;
        console.log(response);
      })
  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .controller('comentsController', comentsController);

  /** @ngInject */
  function comentsController(Api) {
    var vm = this;

    Api.get('/publications/comments')
      .then(function(response) {
        vm.data = response.data.comments
        console.log(vm.data);
      })
  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .service('Api', Api);

  function Api ($http) {
    var api = 'http://vps340939.ovh.net:3001/';
    this.endpoint = api;
    this.get = function (url) {
      return $http.get(api + url).then(function (response) {
        return response;
      })
    }
    this.post = function (url, data) {
      return $http.post(api + url, data).then(function (response) {
        return response;
      })
    }
    this.put = function (url, data) {
      return $http.put(api + url, data).then(function (response) {
        return response;
      })
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .controller('aboutController', aboutController);

  /** @ngInject */
  function aboutController(Api) {
    var vm = this;

    Api.get('/publications/about')
      .then(function(response) {
        vm.data = response.data.texts[0].text;
        console.log(vm.data);
      })
  }
})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
      })
      .state('about', {
        url: '/about',
        templateUrl: 'app/about/about.html',
        controller: 'aboutController',
        controllerAs: 'about'
      })
      .state('products', {
        url: '/products',
        templateUrl: 'app/products/products.html',
        controller: 'productsController',
        controllerAs: 'products',
        params: {scrollTo: false}
      })
      .state('training', {
        url: '/products/training',
        templateUrl: 'app/training/training.html',
        controller: 'trainingController',
        controllerAs: 'training'
      })
      .state('survey', {
        url: '/products/survey',
        templateUrl: 'app/survey/survey.html',
        controller: 'surveyController',
        controllerAs: 'survey'
      })
      .state('coments', {
        url: '/coments',
        templateUrl: 'app/coments/coments.html',
        controller: 'comentsController',
        controllerAs: 'coments'
      })
      .state('events', {
        url: '/events',
        templateUrl: 'app/events/events.html',
        controller: 'eventsController',
        controllerAs: 'events'
      })
      .state('singleEvent', {
        url: '/events/:id',
        templateUrl: 'app/single-event/single-event.html',
        controller: 'singleEventController',
        controllerAs: 'event'
      })
      .state('coming', {
        url: '/coming-soon',
        templateUrl: 'app/coming/coming.html'
      })

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('winegocjacjeWww')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("winegocjacjeWww").run(["$templateCache", function($templateCache) {$templateCache.put("app/about/about.html","<section class=\"about container\"><h1 class=text-center>O NAS</h1><div class=banner><div class=\"col-xs-12 col-sm-6\"><img class=banner-img src=../assets/images/ikona4.png alt=\"\"></div><!--\n    --><div class=\"col-xs-12 col-sm-6 banner-text\"><p><b>Self</b> Training</p><p>nowoczesne</p><p>technologie rozwoju</p></div><div class=clearfix></div></div><div ng-bind-html=about.data></div></section><img style=\"width: 100%\" src=../assets/images/dotted-arc.png alt=\"\">");
$templateCache.put("app/coments/coments.html","<section class=coments><div class=coments__top-img-wrapper><img class=coments__top-img src=../assets/images/girl.png alt=\"\"></div><div class=container><h1 class=text-center>Opinie</h1><banner img=\"\'icon-check.png\'\"><banner-title><p>{{coments.data[0].name}}</p></banner-title><banner-body><p>{{coments.data[0].title}}</p><p>{{coments.data[0].text}}</p></banner-body></banner><div class=coments__content><comment ng-repeat=\"comment in coments.data track by $index\"><comment-title>{{comment.name}}</comment-title><comment-subtitle>{{comment.title}}</comment-subtitle><comment-body>{{comment.text}}</comment-body></comment></div></div><img style=\"width: 100%\" src=../assets/images/dotted-arc.png alt=\"\"></section>");
$templateCache.put("app/coming/coming.html","<!-- <acme-navbar></acme-navbar> --><style media=screen>body {\n    background: #656265;\n  }\n  .home-link{\n    cursor: pointer;\n    margin-top: 30px;\n  }\n  .home-link:hover{\n    color: #EC6933;\n  }</style><section style=\"padding-top: 200px; text-align: center; color: white\" class=container><div class=\"coming col-sm-6 col-sm-offset-3\"><img style=\"width: 100%\" src=assets/images/Logo2.png><h1>Strona w budowie</h1><div class=coming_text>Już niedługo więcej informacji!</div><div ui-sref=home class=home-link>Powrót na stronę główną.</div></div></section>");
$templateCache.put("app/events/events.html","<section class=events><div class=container><h1 class=text-center>AKTUALNOŚCI</h1><div class=events__content><event ng-repeat=\"event in events.events\" img=event.imgUrl class=\"col-sm-6 col-md-4 col-xs-12\" ng-attr-more=\"event.text ? event._id : \'\'\"><event-date>{{event.date | date:\'dd.MM.yyyy\'}}</event-date><event-title>{{event.title}}</event-title><event-body>{{event.subtitle}}</event-body></event><!-- <event class=\"col-sm-6 col-md-4 col-xs-12\" more=\"false\">\n        <event-date>\n          WRZESIEŃ<br>2018\n        </event-date>\n        <event-title>\n          “Go4Apply” - aplikacja rozwoju kompetencji rekrutacyjnych\n        </event-title>\n        <event-body>\n        </event-body>\n      </event>\n      <event class=\"col-sm-6 col-md-4 col-xs-12\" more=\"false\">\n        <event-date>\n          MAJ<br>2018\n        </event-date>\n        <event-title>\n          “Platforma Negocjacyjna” - aplikacja webowa podnosząca kompetencje o charakterze negocjacyjnym w życiu zawodowym i prywatnym\n        </event-title>\n        <event-body>\n        </event-body>\n      </event>\n      <event class=\"col-sm-6 col-md-4 col-xs-12\" more=\"false\">\n        <event-date>\n          GRUDZIEŃ<br>2017\n        </event-date>\n        <event-title>\n          “Negocjator Płac” - aplikacja rozwijająca kompetencje w zakresie negocjacji warunków zatrudnienia\n        </event-title>\n        <event-body>\n        </event-body>\n      </event>\n      <event class=\"col-sm-6 col-md-4 col-xs-12\" more=\"false\">\n        <event-date>\n          PAŹDZIERNIK<br>2017\n        </event-date>\n        <event-title>\n          “PlanTraining” - aplikacja wspierająca trenera w trakcie planowania prowadzenia szkoleń\n        </event-title>\n        <event-body>\n        </event-body>\n      </event>\n      <event class=\"col-sm-6 col-md-4 col-xs-12\" more=\"false\">\n        <event-date>\n          WRZESIEŃ<br>2017\n        </event-date>\n        <event-title>\n          “Negocjacje zaawansowane” Gdańsk - szkolenie otwarte z wykorzystaniem aplikacji “WINegocjacje Training & Development\n        </event-title>\n        <event-body>\n        </event-body>\n      </event>\n      <event class=\"col-sm-6 col-md-4 col-xs-12\" more=\"false\">\n        <event-date>\n          SIERPIEŃ<br>2017\n        </event-date>\n        <event-title>\n          “Negocjacje zaawansowane” Warszawa - szkolenie otwarte z wykorzystaniem aplikacji “WINegocjacje Training & Development”\n        </event-title>\n        <event-body>\n        </event-body>\n      </event>\n      <event class=\"col-sm-6 col-md-4 col-xs-12\" more=\"false\">\n        <event-date>\n          MAJ<br>2017\n        </event-date>\n        <event-title>\n          udział w XXV-tej edycji Kongresu Kadry “Gdzie technologia spotyka człowieka”\n        </event-title>\n        <event-body>\n        </event-body>\n      </event>\n      <event class=\"col-sm-6 col-md-4 col-xs-12\" more=\"false\">\n        <event-date>\n          KWIECIEŃ<br>2017\n        </event-date>\n        <event-title>\n          premiera aplikacji “WINegocjacje Competency Survey DC/AC”\n        </event-title>\n        <event-body>\n        </event-body>\n      </event>\n      <event class=\"col-sm-6 col-md-4 col-xs-12\" more=\"false\">\n        <event-date>\n          LUTY<br>2017\n        </event-date>\n        <event-title>\n          premiera aplikacji “WINegocjacje Training & Development”\n        </event-title>\n        <event-body>\n        </event-body>\n      </event> --></div></div><img style=\"width: 100%\" src=../assets/images/dotted-arc.png alt=\"\"></section>");
$templateCache.put("app/mail-modal/mail-modal.html","<div class=\"col-sm-12 mail-modal\"><h1 class=text-center>Wyślij wiadomość</h1><form ng-submit=vm.sendMail.submit()><input class=\"mail-modal__input col-sm-6 col-sm-offset-3\" type=text name=\"\" placeholder=\"Imię i Nazwisko\" required ng-model=vm.sendMail.name><br><input class=\"mail-modal__input col-sm-6 col-sm-offset-3\" type=email name=\"\" placeholder=E-mail required ng-model=vm.sendMail.mail><br><input class=\"mail-modal__input col-sm-6 col-sm-offset-3\" type=text name=\"\" placeholder=Telefon ng-model=vm.sendMail.phone><br><textarea class=\"mail-modal__textarea col-sm-6 col-sm-offset-3\" name=name rows=4 placeholder=Wiadomość required ng-model=vm.sendMail.message></textarea><div ng-show=vm.mailSuccess class=\"col-sm-12 text-center\" style=\"color: #ff5b00; font-size: 2rem; margin-top: 10px\">Wiadomość została wysłana!</div><div class=clearfix></div><button type=submit name=button class=newsletter-send>WYŚLIJ</button></form></div><div class=clearfix></div>");
$templateCache.put("app/main/main.html","<div id=section-grey><div id=main-slider class=container><div class=slider__background><div class=\"owl-carousel main-carousel owl-theme col-sm-8 col-sm-offset-2\"><div class=item><img src=assets/images/main-carousel-2.png></div><div class=item><img src=assets/images/main-carousel-1.png></div></div></div></div><div id=products class=container><h1 class=products__title>PRODUKTY</h1><div class=main__products-wrapper><div class=\"main__product col-sm-4\"><div class=text-center><img style=\"width: 100%; max-width: 250px; margin: 30px 0\" src=../assets/images/ikona1.png><p style=\"font-size: 4rem; color: white; margin-bottom: 0; line-height: 1\"><b>win</b>egocjacje</p><p class=product__subname style=\"font-size: 2.2rem\">training & development</p><br><p class=product__info style=\"font-size: 1.3rem\">to internetowa aplikacja szkoleniowa umożliwiająca uczestnikom szkolenia prowadzenie negocjacji w czasie rzeczywistym. Jest innowacyjnym narzędziem, które sprawia, że uczestnicy zdobywają umiejętności poprzez udział w praktycznych sytuacjach negocjacyjnych.</p></div><button ui-sref=products>WIĘCEJ</button></div><div class=\"main__product col-sm-4\"><div class=text-center><img style=\"width: 100%; max-width: 250px; margin: 30px 0\" src=../assets/images/ikona2.png><p style=\"font-size: 4rem; color: white; margin-bottom: 0; line-height: 1\"><b>win</b>egocjacje</p><p class=product__subname style=\"font-size: 2.2rem\">competency survey</p><br><p class=product__info style=\"font-size: 1.3rem\">to internetowa aplikacja umożliwiająca asesorom i menedżerom prowadzącym procesy rekrutacyjne typu Assessment Center oraz rozwojowe np. Development Center obiektywną diagnozę kompetencji negocjacyjnych.</p></div><button ui-sref=\"products({scrollTo:\'purple\'})\">WIĘCEJ</button></div><div class=\"main__product col-sm-4\"><div class=text-center><img style=\"width: 100%; max-width: 250px; margin: 30px 0\" src=../assets/images/ikona3.png><p style=\"font-size: 4rem; color: white; margin-bottom: 0; line-height: 1\">zostań</p><p class=product__subname style=\"font-size: 2.2rem\">naszym ambasadorem</p><br><p class=product__info style=\"font-size: 1.3rem\">Uważasz, że Twoja firma może być zainteresowana zakupem aplikacji?</p></div><button ui-sref=\"products({scrollTo:\'red\'})\">WIĘCEJ</button></div></div><div class=clearfix></div><!-- <banner img=\"\'ikona1.png\'\">\n      <banner-title style=\"color: white;\">\n        <p style=\"font-size: 4rem;\"><b>win</b>egocjacje</p>\n      </banner-title>\n      <banner-body>\n        <p class=\"product__subname\">training & development</p></br>\n        <p class=\"product__info\">\n          to internetowa aplikacja szkoleniowa umożliwiająca uczestnikom szkolenia prowadzenie negocjacji w czasie rzeczywistym. Jest innowacyjnym narzędziem, które sprawia, że uczestnicy zdobywają umiejętności poprzez udział w praktycznych sytuacjach negocjacyjnych.\n        </p>\n        <button ui-sref=\"products\">WIĘCEJ</button>\n      </banner-body>\n    </banner>\n    <div class=\"clearfix\"></div>\n    <banner img=\"\'ikona2.png\'\">\n      <banner-title style=\"color: white;\">\n        <p style=\"font-size: 4rem;\"><b>win</b>egocjacje</p>\n      </banner-title>\n      <banner-body>\n        <p class=\"product__subname\">competency survey DC/AC</p></br>\n        <p class=\"product__info\">\n          to internetowa aplikacja umożliwiająca asesorom i menedżerom prowadzącym procesy rekrutacyjne typu Assessment Center oraz rozwojowe np. Development Center obiektywną diagnozę kompetencji negocjacyjnych.\n        </p>\n        <button ui-sref=\"products({scrollTo:\'purple\'})\">WIĘCEJ</button>\n      </banner-body>\n    </banner>\n    <div class=\"clearfix\"></div>\n    <banner img=\"\'ikona3.png\'\">\n      <banner-title style=\"color: white;\">\n        <p style=\"font-size: 4rem;\">zostań</p>\n      </banner-title>\n      <banner-body>\n        <p class=\"product__subname\">naszym ambasadorem</p></br>\n        <p class=\"product__info\">\n          Wynagrodzenie za polecenie\n        </p>\n        <button ui-sref=\"products({scrollTo:\'red\'})\">WIĘCEJ</button>\n      </banner-body>\n    </banner> --></div><img style=\"width: 100%\" src=../assets/images/grey-light-arc.png alt=\"\"></div><div id=section-light><div id=aboutUs class=container><h1 class=products__title>O NAS</h1><div class=\"col-xs-10 col-xs-offset-1 product__tile\"><div class=\"col-xs-12 col-sm-6\"><div class=product__image style=\"background-image: url(\'assets/images/ikona4.png\')\"></div></div><div class=\"col-xs-12 col-sm-6 padding-zero\" style=\"padding-top: 15px\"><p class=product__name>MISJA</p><br><p class=product__subname></p><br><p class=product__info>SELF TRAINING to firma stworzona przez zespół ludzi z pasją, którzy już dawno zdali sobie sprawę z tego, że rozwiązania informatyczne wkroczyły niemal w każdą dziedzinę życia. Mając tego świadomość SELF TRANING kreuje i produkuje narzędzia szkoleniowe oraz nowoczesne rozwiązania informatyczne i metodologiczne wspomagające procesy rozwojowe pracowników.</p><button ui-sref=about>WIĘCEJ</button></div></div></div><img style=\"width: 100%; position: absolute\" src=../assets/images/light-transparent-arc.png alt=\"\"></div><div class=clearfix></div><div id=section-orange><div id=opinions-slider class=container><h1 class=products__title>OPINIE</h1><div class=\"col-xs-10 col-xs-offset-1 owl-carousel comments-carousel owl-theme\"><!-- <div class=\"item\">\n            <div id=\"aboutUs\">\n              <div class=\"product__tile\">\n                <div class=\"col-xs-12 col-sm-6\">\n                  <div class=\"product__image hidden-xs\" style=\"background-image: url(\'assets/images/Cloud5.png\')\"></div>\n                </div>\n                <div class=\"col-xs-12 col-sm-6 padding-zero\" style=\"padding-top: 50px\">\n                  <p class=\"product__name\">MARIUSZ KOWALSKI</p></br>\n                  <p class=\"product__subname\">Lorem ipsum dolor sit amet</p></br>\n                  <p class=\"product__info\">Lorem ipsum dolor sit amet enim. Etiam ullamcorper. Suspendisse a pellentesque dui, non felis. Maecenas malesuada elit lectus felis, malesuada ultricies. Curabitur et ligula. Ut molestie a, ultricies porta urna. Vestibulum commodo volutpat a, convallis ac, laoreet enim. Phasellus fermentum in, dolor. Pellentesque facilisis. Nulla imperdiet sit amet magna.</p>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"item\">\n            <div id=\"aboutUs\">\n              <div class=\"product__tile\">\n                <div class=\"col-xs-12 col-sm-6\">\n                  <div class=\"product__image hidden-xs\" style=\"background-image: url(\'assets/images/Cloud5.png\')\"></div>\n                </div>\n                <div class=\"col-xs-12 col-sm-6 padding-zero\" style=\"padding-top: 50px\">\n                  <p class=\"product__name\">DARIUSZ DAREK</p></br>\n                  <p class=\"product__subname\">Lorem ipsum dolor sit amet</p></br>\n                  <p class=\"product__info\">Lorem ipsum dolor sit amet enim. Etiam ullamcorper. Suspendisse a pellentesque dui, non felis. Maecenas malesuada elit lectus felis, malesuada ultricies. Curabitur et ligula. Ut molestie a, ultricies porta urna. Vestibulum commodo volutpat a, convallis ac, laoreet enim. Phasellus fermentum in, dolor. Pellentesque facilisis. Nulla imperdiet sit amet magna.</p>\n                </div>\n              </div>\n            </div>\n          </div> --><div class=item ng-repeat=\"item in main.carousel\" ng-repeat-end=main.commentsInit()><div id=aboutUs><div class=product__tile style=\"padding: 0\"><div class=\"col-xs-12 col-sm-6\"><div class=\"product__image hidden-xs\" style=\"background-image: url(\'assets/images/Cloud5.png\')\"></div></div><div class=\"col-xs-12 col-sm-6 padding-zero\" style=\"padding-top: 70px\"><p class=product__name>{{item.name}}</p><br><p class=product__subname>{{item.title}}</p><br><p class=product__info>{{item.text}}</p></div></div></div></div></div></div></div><div class=clearfix></div><div id=section-comics><img style=\"width: 100%\" src=assets/images/comics.png alt=\"\"></div><div id=section-contact ng-if=main.events><h1 class=\"contact__title container text-center\" style=\"margin-top: 0\">AKTUALNOŚCI</h1><div class=\"news container\"><div class=\"owl-carousel news-carousel owl-theme col-xs-11 col-sm-10 col-sm-offset-1\"><event ng-repeat=\"event in main.events\" img=event.imgUrl ng-attr-more=\"event.text ? event._id : \'\'\" ng-repeat-end=main.eventsInit()><event-date>{{event.date | date:\'dd.MM.yyyy\'}}</event-date><event-title>{{event.title}}</event-title><event-body>{{event.subtitle}}</event-body></event></div></div></div>");
$templateCache.put("app/products/products.html","<section class=products><div class=orange><h1 class=text-center>POZNAJ NASZE PRODUKTY</h1><div class=container><banner img=\"\'icon-win.png\'\"><banner-title><p><span class=animate-wobble><b>win</b></span>egocjacje</p></banner-title><banner-body><p>Training & Development</p></banner-body></banner><div class=\"title animate-pulse\">Jeśli prowadzisz lub organizujesz szkolenia i…</div><hr><ul><li>Szukasz narzędzia, dzięki któremu <span class=animate-wobble><b>efektywność</b></span> Twoich <span class=animate-wobble><b>szkoleń</b></span> wzrośnie <span class=animate-wobble><b>powyżej 80%?</b></span></li><li>Chcesz pracować z <span class=animate-wobble><b>nowoczesnym symulatorem</b></span> negocjacji, dzięki któremu uczestnicy zdobędą <span class=animate-wobble><b>praktyczne umiejętności</b></span> w <span class=animate-wobble><b>łatwy i przyjemny</b></span> sposób?</li><li>Uważasz, że warto wykorzystać ćwiczenia szkoleniowe, które tak podnoszą <span class=animate-wobble><b>emocje uczestników</b></span>, że po szkoleniu wychodzą z wypiekami na twarzy i jeszcze <span class=animate-wobble><b>długo po</b></span> nim toczą <span class=animate-wobble><b>dyskusje merytoryczne</b></span>?</li><li>Potrzebujesz <span class=animate-wobble><b>innowacyjnej aplikacji</b></span>, która sama kreuje <span class=animate-wobble><b>serię praktycznych zadań</b></span> negocjacyjnych, a następnie każdemu uczestnikowi <span class=animate-wobble><b>pokazuje mierzalną informację</b></span> zwrotną?</li><li>Myślisz o profesjonalnym symulatorze procesu negocjacji, który <span class=animate-wobble><b>z łatwością</b></span> możesz <span class=animate-wobble><b>dostosować do merytoryki</b></span> szkolenia oraz realiów negocjacyjnych <span class=animate-wobble><b>każdej branży i firmy</b></span>?</li></ul><hr><ul><li>Zastanawiasz się czy nie warto skorzystać z <span class=animate-wobble><b>zaawansowanej technologii</b></span>, która nie przysporzy Ci problemów z obsługą lecz <span class=animate-wobble><b>poprowadzi</b></span> Cię <span class=animate-wobble><b>płynnie krok po kroku</b></span>?</li><li>Chcesz prowadzić takie szkolenia, na których <span class=animate-wobble><b>uczestnicy od razu testują</b></span> zdobywaną wiedzę i <span class=animate-wobble><b>utrwalają</b></span> w praktyce <span class=animate-wobble><b>nowe umiejętności</b></span>?</li><li>Potrzebujesz aplikacji szkoleniowej, w której <span class=animate-wobble><b>poziom trudności</b></span> możesz <span class=animate-wobble><b>stopniować zależnie od</b></span> zaawansowania uczestników i Twojej <span class=animate-wobble><b>koncepcji szkolenia</b></span>?</li></ul><hr><ul><li>Szukasz <span class=animate-wobble><b>rozwiązania</b></span>, które się <span class=animate-wobble><b>nie starzeje</b></span>, ponieważ jest <span class=animate-wobble><b>ciągle udoskonalane</b></span>, dopasowywane do potrzeb użytkowników i podążające <span class=animate-wobble><b>z nowoczesnymi technologiami rozwoju</b></span>?</li><li>Uważasz, że warto zrezygnować z nudnych testów i móc <span class=animate-wobble><b>na każdym etapie</b></span> szkolenia <span class=animate-wobble><b>diagnozować poziom</b></span> umiejętności uczestników oraz <span class=animate-wobble><b>badać</b></span> ich <span class=animate-wobble><b>realny przyrost kompetencji</b></span>?</li><li>Chcesz pracować z narzędziem szkoleniowym, które umożliwi <span class=animate-wobble><b>płynną kontynuację szkolenia</b></span> i powrót do konkretnych sytuacji negocjacyjnych <span class=animate-wobble><b>nawet po kilku miesiącach</b></span>?</li></ul><hr><div class=\"title animate-pulse\">To aplikacja WINegocjacje Training & Development jest dla Ciebie!</div><banner img=\"\'icon-win.png\'\"><banner-title><p><span class=animate-wobble><b>win</b></span>egocjacje</p></banner-title><banner-body><p>Training & Development</p></banner-body></banner><div class=title>to internetowa aplikacja szkoleniowa umożliwiająca uczestnikom szkolenia prowadzenie negocjacji w czasie rzeczywistym. Jest innowacyjnym narzędziem, które sprawia, że uczestnicy zdobywają umiejętności poprzez udział w praktycznych sytuacjach negocjacyjnych.</div><p>W aplikacji stworzona została symulacja rynku negocjacyjnego, w której każdy uczestnik szkolenia realizuje indywidualny (przygotowany w aplikacji) scenariusz biznesowy. Przed każdym uczestnikiem lub zespołem postawione są konkretne cele negocjacyjne, a kompetencje mierzone są skutecznością i efektywnością ich realizacji.</p><p>Rynek w Symulacji to stworzona na potrzeby aplikacji wirtualna przestrzeń ekonomiczna, w której cztery firmy kupujące oraz cztery firmy sprzedające prowadzą negocjacje.</p><p>Symulacja umożliwia przeprowadzenie dowolnej ilości rund negocjacyjnych, w których każdy uczestnik lub zespół prowadzi cztery rozmowy ze swoimi kontrahentami. Dzięki temu aplikacja tworzy dynamiczny rdzeń szkolenia, który emocjonalnie wciąga uczestników, wzmacnia ich zaangażowanie oraz chęć wykorzystywania wiedzy i umiejętności w praktyce.</p><p>Dodatkowo w naturalny sposób tworzy niepowtarzalne ćwiczenia szkoleniowe (case study), których uczestnicy nieświadomie stają się współtwórcami. Dzięki temu trener nie musi skupiać się na przygotowywaniu ćwiczeń szkoleniowych lecz może skoncentrować się wyłącznie na przekazaniu wiedzy merytorycznej, która jest zamieniana na umiejętności i testowana w praktyce w każdej rundzie negocjacyjnej.</p><p>Taka organizacja szkolenia umożliwia trenerowi obserwację uczestników w realnej sytuacji negocjacyjnej, a przez to obiektywną diagnozę ich kompetencji, co umożliwia udzielenie zindywidualizowanej informacji zwrotnej dla uczestnika lub zespołu.</p><div style=\"margin-top: 20px\" class=text-center><button type=button name=button ui-sref=training>KUPUJĘ</button> <button type=button name=button ng-click=\"products.scrollTo(\'contact__title\', 0)\">SKONTAKTUJ SIĘ</button></div></div><img style=\"width: 100%\" src=../assets/images/orang-purple-arc.png alt=\"\"></div><div class=purple><div class=container><banner img=\"\'icon-comp.png\'\"><banner-title><p><span class=animate-wobble><b>win</b></span>egocjacje</p></banner-title><banner-body><p>Competency Survey</p></banner-body></banner><div class=\"title animate-pulse\">Jeśli prowadzisz lub organizujesz procesy rekrutacyjne lub Development Center i…</div><hr><ul><li>Szukasz <span class=animate-wobble><b>unikalnej</b></span> i nowoczesnej <span class=animate-wobble><b>metody pomiaru</b></span> i rozwoju <span class=animate-wobble><b>kompetencji</b></span> negocjacyjnych?</li><li>Chcesz przeprowadzić procesy <span class=animate-wobble><b>Development Center</b></span> (DC) i <span class=animate-wobble><b>Assessment Center</b></span> (AC) z nowoczesną aplikacją, która dostarcza <span class=animate-wobble><b>wyniki</b></span> proste i <span class=animate-wobble><b>łatwe do analizy</b></span>?</li><li>Uważasz, że warto mieć narzędzie, które tak <span class=animate-wobble><b>angażuje uczestnika rekrutacji</b></span> lub procesu DC, że zapomina o tym, iż jest obserwowany i przez to <span class=animate-wobble><b>uwidacznia</b></span> swoje <span class=animate-wobble><b>naturalne predyspozycje</b></span>?</li></ul><hr><ul><li>Potrzebujesz symulatora do badania kompetencji negocjacyjnych, który <span class=animate-wobble><b>miękkie umiejętności</b></span> przedstawi <span class=animate-wobble><b>w postaci twardych wskaźników</b></span> skuteczności i efektywności?</li><li>Chcesz mieć <span class=animate-wobble><b>uniwersalne ćwiczenie</b></span> negocjacyjne, które ułatwi <span class=animate-wobble><b>dawanie informacji zwrotnej</b></span> w procesach rozwojowych lub rekrutacyjnych?</li></ul><hr><ul><li>Zastanawiasz się, czy nie warto skorzystać z <span class=animate-wobble><b>zaawansowanego rozwiązania</b></span>, które Ciebie i uczestnika <span class=animate-wobble><b>poprowadzi</b></span> przez proces diagnozy kompetencji w <span class=animate-wobble><b>łatwy i intuicyjny sposób</b></span>?</li><li>Potrzebujesz <span class=animate-wobble><b>inteligentnego zadania</b></span> negocjacyjnego, w którym <span class=animate-wobble><b>poziom trudności</b></span> można płynnie <span class=animate-wobble><b>dopasować</b></span> do badanej grupy oraz <span class=animate-wobble><b>do Twoich wymagań</b></span>?</li><li>Uważasz, że warto w <span class=animate-wobble><b>procesie rekrutacji</b></span> badać kompetencje negocjacyjne z wykorzystaniem aplikacji gwarantującej <span class=animate-wobble><b>bezstronny</b></span> i w pełni <span class=animate-wobble><b>obiektywny pomiar</b></span> (np. eliminującej efekt znużenia aktora/asesora)?</li></ul><hr><ul><li>Chcesz zbudować <span class=animate-wobble><b>pozytywny wizerunek</b></span> firmy w oczach kandydata już przy pierwszym kontakcie, czyli <span class=animate-wobble><b>podczas procesu rekrutacji</b></span>?</li><li>Dochodzisz do wniosku, czy nie szukasz narzędzia, które <span class=animate-wobble><b>wyeliminuje zdemotywowanie</b></span> pracowników <span class=animate-wobble><b>w rekrutacjach wewnętrznych</b></span> i procesach oceny poprzez transparentność i obiektywizm wyników?</li><li>Chcesz mieć <span class=animate-wobble><b>możliwość porównywania</b></span> identycznych i niezmiennych <span class=animate-wobble><b>wskaźników</b></span> poziomu rozwoju pracownika <span class=animate-wobble><b>w dowolnym odstępie czasu</b></span> na tle jego całej kariery w firmie?</li></ul><hr><div class=\"title animate-pulse\">To aplikacja <span class=animate-wobble><b>WIN</b></span>egocjacje Competency Survey DC/AC jest dla Ciebie!</div><banner img=\"\'icon-comp.png\'\"><banner-title><p><span class=animate-wobble><b>win</b></span>egocjacje</p></banner-title><banner-body><p>Competency Survey</p></banner-body></banner><div class=title>to internetowa aplikacja umożliwiająca asesorom i menedżerom prowadzącym procesy rekrutacyjne typu Assessment Center oraz rozwojowe np. Development Center obiektywną diagnozę kompetencji negocjacyjnych.</div><p>Zastosowana w aplikacji symulacja rynku negocjacyjnego pozwala na realizowanie przez badane osoby indywidualnych scenariuszy biznesowych. Stopień realizacji celów negocjacyjnych pozwala w obiektywny sposób zmierzyć skuteczność i efektywność diagnozowanego uczestnika w kontekście kompetencji negocjacyjnych.</p><p>Na potrzeby badania poziomu umiejętności negocjacyjnych stworzona została wirtualna przestrzeń ekonomiczna, w której cztery firmy kupujące oraz cztery firmy sprzedające prowadzą negocjacje. W przypadku badania mniej niż ośmiu pracowników nieobsadzone firmy w symulacji zastępują odpowiednio dobrani aktorzy.</p><p>Symulacja umożliwia przeprowadzenie dowolnej ilości rund negocjacyjnych, w których każdy uczestnik prowadzi cztery rozmowy ze swoimi kontrahentami. Celem każdej rundy jest osiągnięcie przez osobę diagnozowaną najwyższej realizacji planów negocjacyjnych. Po rundzie w aplikacji prezentowane są wyniki rozmów negocjacyjnych, czyli twarde, obiektywne dane, które w wymierny sposób obrazują wyniki badania kompetencji negocjacyjnych pracownika.</p><p>Dodatkowo Symulator w naturalny sposób tworzy niepowtarzalne ćwiczenia negocjacyjne (case study), których uczestnicy nieświadomie stają się współuczestnikami. Każdy z badanych pracowników wykazuje maksimum zaangażowania, przez co interakcje między uczestnikami mają charakter bardziej naturalny. Jednocześnie ograniczane są do minimum potencjalne przekłamania w obserwacji poszczególnych wskaźników – spowodowane tzw. błędem ludzkim jak np. zmęczenie aktora.</p><p>Organizator badania nie musi skupiać się na przygotowywaniu ćwiczeń diagnozujących poziom kompetencji, a asesor może skoncentrować się wyłącznie na obserwacji. Dzięki temu dokona obiektywnej diagnozy poziomu wiedzy i umiejętności, co umożliwi udzielenie zindywidualizowanej informacji zwrotnej dla uczestnika lub opracowanie rzetelnego raportu.</p><p>W wielu sytuacjach (np. w ramach procesu rekrutacji) narzędziem umożliwiającym obiektywną ocenę jest generowany przez aplikację ranking wyników negocjacyjnych uczestników – będący praktycznym odzwierciedleniem rzeczywistego poziomu ich kompetencji.</p><div style=\"margin-top: 20px\" class=text-center><button type=button name=button ui-sref=survey>KUPUJĘ</button> <button type=button name=button ng-click=\"products.scrollTo(\'contact__title\', 0)\">SKONTAKTUJ SIĘ</button></div></div><img style=\"width: 100%\" src=../assets/images/purple-red-arc.png alt=\"\"></div><div class=red><div class=container><banner img=\"\'icon-amba.png\'\"><banner-title><p>zostań</p></banner-title><banner-body><p>naszym ambasadorem</p><!-- <p style=\"font-size: 1.5rem;\">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> --></banner-body></banner><ul><li>Wynagrodzenie za polecenie – napisz do nas: <a ng-click=products.mailModalOpen()>ambasador@winegocjacje.com</a></li><li>Myślisz, że szkolenie z negocjacji przyda się w firmie, w której obecnie pracujesz? – napisz do nas: <a ng-click=products.mailModalOpen()>ambasador@winegocjacje.com</a></li><li>Znasz osobę w innej firmie, która byłaby zainteresowana zakupem licencji na WINegocjacje lub kupnem szkoleń z negocjacji? – napisz do nas: <a ng-click=products.mailModalOpen()>ambasador@winegocjacje.com</a></li></ul><!-- <panel-collapse border-top=\'true\'>\n        <panel-collapse-title>\n          wynagrodzenie za polecenie\n        </panel-collapse-title>\n        <panel-collapse-body>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n        </panel-collapse-body>\n      </panel-collapse>\n      <panel-collapse>\n        <panel-collapse-title>\n          chcę sprzedawać producty i szkolenia\n        </panel-collapse-title>\n        <panel-collapse-body>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n        </panel-collapse-body>\n      </panel-collapse>\n      <panel-collapse>\n        <panel-collapse-title>\n          chcę zlecić wykonanie nowego / indywidualnego produktu\n        </panel-collapse-title>\n        <panel-collapse-body>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n        </panel-collapse-body>\n      </panel-collapse>\n      <panel-collapse>\n        <panel-collapse-title>\n          mam inny pomysł współpracy\n        </panel-collapse-title>\n        <panel-collapse-body>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n        </panel-collapse-body>\n      </panel-collapse> --></div><img style=\"width: 100%\" src=../assets/images/red-grey-arc.png alt=\"\"></div></section>");
$templateCache.put("app/single-event/single-event.html","<section class=single-event><div class=container><h1 class=text-center>AKTUALNOŚCI</h1><div ng-if=event.data class=single-event__img ng-style=\"event.data.imgUrl ? {\'background\': \'url(http://vps340939.ovh.net:3001/{{event.data.imgUrl}})\'} : {\'background\': \'url(assets/images/fotolia.png)\'}\"></div><div class=single-event__date>{{event.data.date | date:\'dd.MM.yyyy\'}}</div><div class=single-event__content><h1 class=\"text-center main-title\">{{event.data.title}}</h1><div ng-bind-html=event.data.text></div></div></div><img style=\"width: 100%\" src=../assets/images/dotted-arc.png alt=\"\"></section><!-- <section class=\'single-event\'>\n  <div class=\"container\">\n    <h1 class=\"text-center\">AKTUALNOŚCI</h1>\n    <img class=\"single-event__img\" src=\"../assets/images/fotolia.png\" alt=\"\">\n    <div class=\"single-event__date\">\n      8-9 <br>\n      MAJ<br>2017\n    </div>\n    <div class=\"single-event__content\">\n      <h1 class=\"text-center\">\"Gdzie technologia spotyka człowieka” - Kongres Kadry</h1>\n      <p>W dniach 8-9 maja 2017 mieliśmy przyjemność uczestniczenia w Kongresie Kadry, którego tematem przewodnim było hasło \"Gdzie technologia spotyka człowieka”.\n      Z uwagi na to, że tworzymy nowoczesne internetowe aplikacje wspomagające szeroko pojęty rozwój ludzi - po prostu nie mogło nas tam zabraknąć!</p>\n      <p>Dziękujemy wszystkim fantastycznym Gościom, których poznaliśmy podczas tych dwóch twórczych dni za ich ciekawe pytania i kreatywne rozmowy. </p>\n      <p>Było nam niezmiernie miło widzieć Wasze super pozytywne reakcje i słuchać komentarzy pełnych zachwytu dotyczących naszych narzędzi. Dziękujemy!</p>\n      <p>Wszystkich, którzy już dziś zdają sobie sprawę, że na pewno warto z nami wspólpracować, tylko jeszcze nie wiedzą JAK, serdecznie zapraszamy aby byli z Nami w kontakcie :-)</p>\n      <p>Do zobaczenia wkrótce <br> Zespół WINegcjacje</p>\"Gdzie technologia spotyka człowieka” -\n      Kongres Kadry\n    </div>\n  </div>\n\n  <img style=\"width: 100%;\" src=\"../assets/images/dotted-arc.png\" alt=\"\">\n</section> -->");
$templateCache.put("app/survey/survey.html","<section class=survey><div class=purple><h1 class=text-center>ZAKUPY</h1><div class=container><banner img=\"\'icon-comp.png\'\"><banner-title><p><b>win</b>egocjacje</p></banner-title><banner-body><p>competency survey</p></banner-body></banner><div class=title><b>Warianty zkupu WINegocjacje Competency Survey DC/AC</b></div><panel-collapse ng-repeat=\"collapse in survey.collapses track by $index\" ng-attr-border-top=\"$first ? true : false\"><panel-collapse-title ng-bind-html=collapse.title></panel-collapse-title><panel-collapse-body ng-bind-html=collapse.text></panel-collapse-body></panel-collapse><!-- <panel-collapse border-top=\'true\'>\n        <panel-collapse-title>\n          I. Licencja na wykorzystanie komercyjne aplikacji WINegocjacje Competency Survey DC/AC\n        </panel-collapse-title>\n        <panel-collapse-body>\n          <ol>\n            <li>Wykupiona licencja pozwala na wykorzystanie aplikacji w celach komercyjnych, a w szczególności do odpłatnego lub bezpłatnego badania kompetencji negocjacyjnych w ramach procesów rozwojowych lub rekrutacyjnych typu Assessment Center lub Development Center.</li>\n            <li>Kupując licencję stajesz się Użytkownikiem aplikacji i otrzymujesz dostęp do Panelu Asesora poprzez otrzymanie na wskazany przez Ciebie adres mailowy linku do aplikacji.</li>\n            <li>Aplikacja przeznaczona jest na 8 stanowisk uczestników diagnozy (zwanych dalej „Uczestnikami”) oraz 1 stanowisko Użytkownika, które przeznaczone jest dla osoby prowadzącej badanie kompetencji negocjacyjnych (zwanej dalej „Asesorem”).</li>\n            <li>Do przeprowadzenia szkolenia potrzebujesz 8 stanowisk uczestników i 1 stanowiska dla Asesora z komputerem lub tabletem (ewentualnie smartfonem – wymagania techniczne znajdziesz tutaj) </li>\n            <li>Z każdego stanowiska uczestnika może w momencie obserwacji korzystać 1 diagnozowana osoba.</li>\n            <li>W przypadku badania mniej niż ośmiu pracowników nieobsadzone stanowiska w symulacji mogą zastąpić odpowiednio dobrani aktorzy.</li>\n            <li>Moment zakupu licencji nie oznacza wystartowania jej czasu trwania. Po zakupieniu licencji można ją wystartować w dowolnym, wybranym przez siebie terminie.</li>\n            <li>Czas trwania licencji liczy się dopiero od momentu jej wystartowania, czyli od chwili pierwszego zalogowania uczestnika symulacji (uczestnika badania kompetencji) do Panelu Uczestnika.</li>\n            <li>W czasie poprzedzającym zalogowanie się uczestnika badania do Symulacji można logować się do Panelu Asesora w dowolnym momencie, dowolną ilość razy i nie rozpoczyna to odliczania czasu trwania licencji.</li>\n            <li>Jako dzień rozpoczęcia trwania czasu licencji rozumie się dzień pierwszego zalogowania Uczestnika symulacji do Panelu Uczestnika. Czas obowiązywania licencji trwa do godziny 23:59 ostatniego dnia licencji.</li>\n            <li>Szczegóły dotyczące opcji wyboru czasu trwania licencji znajdują się w cenniku lub można je ustalić kontaktując się drogą mailową: kontakt@winegocjacje.com</li>\n          </ol>\n          <br>\n          Przykładowo:\n          <ul>\n            <li>Jeśli kupiłeś licencję na 2 dni możesz logować się do Panelu Asesora kiedy tylko chcesz, np. w celu zapoznania się z Symulatorem lub dokonywania w nim zmian dostępnych w opcjach Symulatora. Nie powoduje to wystartowania czasu trwania licencji. </li>\n            <li>Jeśli przykładowo rozpocząłeś proces diagnozy kompetencji 10-go maja i pierwszy Uczestnik zaloguje się do Symulatora o godzinie 14:00, to w tym momencie wystartuje czas trwania licencji. Licencja wygaśnie 11-go maja o godzinie 23:59.</li>\n          </ul>\n        </panel-collapse-body>\n      </panel-collapse>\n      <panel-collapse>\n        <panel-collapse-title>\n          II. Warsztat Asesora aplikacji WINegocjacje Training & Development\n        </panel-collapse-title>\n        <panel-collapse-body>\n          <ol>\n            <li>Warsztat trwa 4 godziny i prowadzony jest przez firmę Self Training Sp. z o.o. po uprzednim ustaleniu miejsca i terminu wraz z Klientem.</li>\n            <li>Warsztat przeznaczony jest dla osób obsługujących aplikację w ramach prowadzonych procesów diagnozy kompetencji negocjacyjnych zwanych dalej Użytkownikami (np. asesorzy, menedżerowie obserwujący uczestników podczas badania).</li>\n            <li>Warsztat może odbyć się w formie zdalnej jeśli dotyczy mniej niż 4 Użytkowników (prowadzących procesy diagnozy kompetencji z wykorzystaniem aplikacji).</li>\n            <li>Warsztat zawiera szczegółowe zasady  wykorzystania wszystkich rozbudowanych opcji i możliwości aplikacji, jednocześnie zakup i ukończenie warsztatu nie jest tożsame z zakupem licencji na komercyjne wykorzystanie aplikacji.</li>\n            <li>Szczegóły można ustalić kontaktując się drogą mailową: kontakt@winegocjacje.com</li>\n          </ol>\n        </panel-collapse-body>\n      </panel-collapse>\n      <panel-collapse>\n        <panel-collapse-title>\n          III. Badanie kompetencji negocjacyjnych z wykorzystaniem aplikacji WINegocjacje Competency Survey DC/AC prowadzone przez Self Training\n        </panel-collapse-title>\n        <panel-collapse-body>\n          <ol>\n            <li>Badanie kompetencji negocjacyjnych z wykorzystaniem aplikacji WINegocjacje Competency Survey DC/AC odbywa się podczas zorganizowanych przez Klienta procesów rozwojowych po uprzedniej konsultacji dotyczącej potrzeb Klienta.</li>\n            <li>Sesja indywidualnej informacji zwrotnej to spotkanie Asesora prowadzącego badającego kompetencje negocjacyjne z uczestnikiem diagnozy. Odbywa się ono w terminie minimum 14 dni po badaniu kompetencji, w terminie i miejscu uzgodnionym z Klientem. Celem sesji jest przekazanie uczestnikowi indywidualnej oceny jego kompetencji negocjacyjnych, mocnych stron i obszarów do rozwoju. </li>\n            <li>W wielu sytuacjach (np. w ramach procesu rekrutacji) narzędziem umożliwiającym obiektywną ocenę jest generowany przez aplikację ranking wyników negocjacyjnych uczestników – będący praktycznym odzwierciedleniem rzeczywistego poziomu ich kompetencji.</li>\n            <li>Szczegóły można ustalić kontaktując się drogą mailową: kontakt@winegocjacje.com</li>\n          </ol>\n        </panel-collapse-body>\n      </panel-collapse> --><div class=title><b>Ceny zkupu WINegocjacje Competency Survey DC/AC</b></div><panel-collapse border-top=true><panel-collapse-title>Ceny licencji</panel-collapse-title><panel-collapse-body>Licencja na wykorzystanie komercyjne aplikacji WINegocjacje Competency Survey DC/AC<div class=visible-xs>dorobić</div><table class=styled-table><thead><tr><td ng-repeat=\"row in survey.data.licens.head track by $index\">{{row}}</td></tr></thead><tbody><tr ng-repeat=\"row in survey.data.licens.body\"><td ng-repeat=\"content in row track by $index\">{{content}}</td></tr></tbody></table></panel-collapse-body></panel-collapse><panel-collapse><panel-collapse-title>Ceny badania AC/DC</panel-collapse-title><panel-collapse-body><div class=table><div class=\"col-sm-12 table-title\">Badanie kompetencji negocjacyjnych z użyciem aplikacji WINegocjacje Competency Survey DC/AC prowadzone przez Self Training</div><div class=col-sm-12 ng-repeat=\"row in survey.data.instruction.train track by $index\"><div class=\"col-sm-6 table-cell\" ng-repeat=\"content in row track by $index\" ng-class=\"$even ? \'\' : \'text-center\' \">{{content}}</div><div class=table-hr ng-if=!$last></div></div><div class=clearfix></div><!-- <div class=\"col-sm-6 table-cell\">\n              Cena netto za diagnozę 1 uczestnika i raport\n            </div>\n            <div class=\"col-sm-6 table-cell text-center\">\n              1500 zł\n            </div>\n            <div class=\"table-hr\"></div>\n            <div class=\"col-sm-6 table-cell\">\n              Cena netto za udzielenie informacji zwrotnej za 1 uczestnika\n            </div>\n            <div class=\"col-sm-6 table-cell text-center\">\n              500 zł\n            </div> --></div></panel-collapse-body></panel-collapse></div><img style=\"width: 100%\" src=../assets/images/purple-grey-arc.png alt=\"\"></div></section>");
$templateCache.put("app/training/training.html","<section class=training><div class=orange><h1 class=text-center>ZAKUPY</h1><div class=container><banner img=\"\'icon-win.png\'\"><banner-title><p><b>win</b>egocjacje</p></banner-title><banner-body><p>training&development</p></banner-body></banner><div class=title><b>Warianty zkupu WINegocjacje Training & Development</b></div><panel-collapse ng-repeat=\"collapse in training.collapses track by $index\" ng-attr-border-top=\"$first ? true : false\"><panel-collapse-title ng-bind-html=collapse.title></panel-collapse-title><panel-collapse-body ng-bind-html=collapse.text></panel-collapse-body></panel-collapse><!-- <panel-collapse>\n        <panel-collapse-title>\n          II. Warsztat Użytkownika aplikacji WINegocjacje Training & Development\n        </panel-collapse-title>\n        <panel-collapse-body>\n          <ol>\n            <li>Warsztat trwa 4 godziny i prowadzony jest przez firmę Self Training Sp. z o.o. po uprzednim ustaleniu miejsca i terminu wraz z Klientem.</li>\n            <li>Warsztat przeznaczony jest dla osób obsługujących aplikację w ramach prowadzonych zajęć dydaktycznych zwanych Użytkownikami.</li>\n            <li>Warsztat może odbyć się w formie zdalnej jeśli dotyczy mniej niż 4 Użytkowników (trenerów prowadzących szkolenie z wykorzystaniem aplikacji).</li>\n            <li>Warsztat zawiera szczegółowe zasady  wykorzystania wszystkich rozbudowanych opcji i możliwości aplikacji, jednocześnie zakup i ukończenie warsztatu nie jest tożsame z zakupem licencji na komercyjne wykorzystanie aplikacji.</li>\n            <li>Szczegóły można ustalić kontaktując się drogą mailową: kontakt@winegocjacje.com</li>\n          </ol>\n        </panel-collapse-body>\n      </panel-collapse>\n      <panel-collapse>\n        <panel-collapse-title>\n          III. Szkolenie typu Train The Trainer z komercyjnym wykorzystaniem Symulatora WINegocjacje Training & Development (np. dla trenerów prowadzących szkolenia wewnętrzne lub zewnętrzne)\n        </panel-collapse-title>\n        <panel-collapse-body>\n          <ol>\n            <li>Jeden dzień szkolenia trwa 8 godzin i prowadzony jest przez firmę Self Training Sp. z o.o. po uprzednim ustaleniu miejsca i terminu wraz z Klientem.</li>\n            <li>Maksymalna liczba uczestników szkolenia to 8 osób.</li>\n            <li>Szkolenie ma charakter Train The Trainer i przeznaczone jest dla osób (np. trenerów, menedżerów) prowadzących lub planujących prowadzić szkolenia lub warsztaty z tematyki negocjacyjnej z wykorzystaniem Symulatora WINegocjacje Training & Development. </li>\n            <li>Szkolenie zawiera szczegółowe zasady  wykorzystania wszystkich rozbudowanych opcji i możliwości aplikacji oraz merytoryczny know-how, konspekt trenera oraz inne materiały dydaktyczne opracowane po uprzedniej konsultacji dotyczącej potrzeb szkoleniowych Klienta.</li>\n            <li>Jednocześnie zakup i ukończenie szkolenia nie jest tożsame z zakupem licencji na komercyjne wykorzystanie aplikacji, którą należy dokupić w ramach wybranej opcji użytkowania.</li>\n            <li>Szczegóły można ustalić kontaktując się drogą mailową: kontakt@winegocjacje.com</li>\n          </ol>\n        </panel-collapse-body>\n      </panel-collapse>\n      <panel-collapse>\n        <panel-collapse-title>\n          IV. Szkolenie negocjacyjne z wykorzystaniem aplikacji WINegocjacje Training & Development prowadzone przez Self Training\n        </panel-collapse-title>\n        <panel-collapse-body>\n          <ol>\n            <li>Jeden dzień szkolenia trwa 8 godzin i prowadzony jest przez firmę Self Training Sp. z o.o. po uprzednim ustaleniu miejsca i terminu wraz z Klientem.</li>\n            <li>Maksymalna liczba uczestników szkolenia to 16 osób.</li>\n            <li>Szkolenie ma charakter warsztatowy i przeznaczone jest dla osób chcących w praktyczny sposób rozwijać kompetencje negocjacyjne. </li>\n            <li>Szkolenie opiera się na programie merytorycznym o różnych poziomach zawansowania opracowanym indywidualnie po uprzedniej konsultacji dotyczącej potrzeb szkoleniowych Klienta.</li>\n            <li>Szkolenie wykorzystuje Symulator WINegocjacje Training & Development, w którym parametry negocjacyjne (ceny, ilości, produkty itp.) mogą być na życzenie Klienta być dopasowane do specyfiki jego branży.</li>\n            <li>Po szkoleniu rekomendowane są sesje indywidualnej informacji zwrotnej dla uczestników szkolenia.</li>\n            <li>Sesja indywidualnej informacji zwrotnej to 30-to minutowe spotkanie trenera prowadzącego szkolenie negocjacyjne z uczestnikiem szkolenia. Odbywa się ono w terminie minimum 14 dni po szkoleniu, w terminie i miejscu uzgodnionym z Klientem. Celem sesji jest przekazanie uczestnikowi indywidualnej oceny jego kompetencji negocjacyjnych, mocnych stron i obszarów do rozwoju przygotowanych na podstawie nagrań video z przeprowadzonego szkolenia.</li>\n            <li>Szczegóły można ustalić kontaktując się drogą mailową: kontakt@winegocjacje.com</li>\n          </ol>\n        </panel-collapse-body>\n      </panel-collapse> --><div class=title><b>Ceny zkupu WINegocjacje Training & Development</b></div><panel-collapse border-top=true><panel-collapse-title>Ceny licencji</panel-collapse-title><panel-collapse-body>Licencja na wykorzystanie komercyjne aplikacji WINegocjacje Training & Development<div class=visible-xs>dorobić</div><table class=styled-table><thead><tr><td ng-repeat=\"row in training.data.licens.head track by $index\">{{row}}</td></tr></thead><tbody><tr ng-repeat=\"row in training.data.licens.body\"><td ng-repeat=\"content in row track by $index\">{{content}}</td></tr></tbody></table><!-- <table class=\"styled-table hidden-xs\">\n            <thead>\n              <tr>\n                <td>Liczba dni - czas trwania licencji</td>\n                <td>1 dzień</td>\n                <td>2 dni</td>\n                <td>3 dni</td>\n                <td>1 rok</td>\n                <td>kolejne lata</td>\n              </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <td>Cena licencji netto</td>\n                <td>1000 zł</td>\n                <td>1800 zł</td>\n                <td>2500 zł</td>\n                <td>84 000 zł</td>\n                <td>minus 10%<br>(minus 8400 zł), za każdy następny rok wykupienia licencji - aż do minus 90%</td>\n              </tr>\n              <tr>\n                <td>Koszt miesięczny licencji netto</td>\n                <td>-</td>\n                <td>-</td>\n                <td>-</td>\n                <td>7 000 zł</td>\n                <td>minus 10%<br>(minus 8400 zł), za każdy następny rok wykupienia licencji - aż do minus 90%</td>\n              </tr>\n              <tr>\n                <td>Cena netto na 1 osobę „Warsztatu Użytkownika” (4 godziny)</td>\n                <td>500 zł</td>\n                <td>500 zł</td>\n                <td>500 zł</td>\n                <td>1 warsztat gratis</td>\n                <td>1 warsztat gratis</td>\n              </tr>\n            </tbody>\n          </table> --></panel-collapse-body></panel-collapse><panel-collapse><panel-collapse-title>Ceny szkoleń</panel-collapse-title><panel-collapse-body><div class=table><div class=\"col-sm-12 table-title\">Szkolenie typu Train The Trainer z komercyjnym wykorzystaniem Symulatora WINegocjacje Training & Development (np. dla trenerów prowadzących szkolenia wewnętrzne lub zewnętrzne)</div><!-- <div class=\"col-sm-12\" ng-repeat=\"row in training.data.instruction.trainTrainer track by $index\"> --><div class=\"col-sm-6 table-cell\" ng-repeat=\"content in training.data.instruction.trainTrainer track by $index\" ng-class=\"$even ? \'\' : \'text-center\' \">{{content}}</div><!-- <div class=\"table-hr\" ng-if=\"!$last\"></div> --><!-- </div> --><!-- <div class=\"col-sm-6 table-cell\">\n              Cena netto za 1 dzień szkolenia (8 godzin, maksymalnie 8 osób)\n            </div>\n            <div class=\"col-sm-6 table-cell text-center\">\n              14 000 zł (cena nie zawiera inwestycji w wybraną opcję licencji)\n            </div> --><div class=table-hr></div><div class=\"col-sm-12 table-title\">Szkolenie negocjacyjne z użyciem aplikacji WINegocjacje Training & Development prowadzone przez Self Training</div><div class=col-sm-12 ng-repeat=\"row in training.data.instruction.trainTrainer track by $index\"><div class=\"col-sm-6 table-cell\" ng-repeat=\"content in training.data.instruction.trainTrainer track by $index\" ng-class=\"$even ? \'\' : \'text-center\' \">{{content}}</div><div class=table-hr ng-if=!$last></div></div><!-- <div class=\"col-sm-6 table-cell\">\n              Cena netto za 1 dzień szkolenia negocjacyjnego (8 godzin, max 16 osób)\n            </div>\n            <div class=\"col-sm-6 table-cell text-center\">\n              8 500 zł\n            </div>\n            <div class=\"table-hr\"></div>\n            <div class=\"col-sm-6 table-cell\">\n              Cena netto za 1 dzień indywidualnych sesji informacji zwrotnej (max 6 osób)\n            </div>\n            <div class=\"col-sm-6 table-cell text-center\">\n              3 500 zł\n            </div>\n            <div class=\"table-hr\"></div>\n            <div class=\"col-sm-6 table-cell\">\n              Cena netto 1 dnia szkolenia otwartego dla 1 uczestnika (grupa 8-16 osób)\n            </div>\n            <div class=\"col-sm-6 table-cell text-center\">\n              1000 zł\n            </div> --></div></panel-collapse-body></panel-collapse></div><img style=\"width: 100%\" src=../assets/images/orange-grey-arc.png alt=\"\"></div></section>");
$templateCache.put("app/components/banner/banner.html","<div class=banner><div class=\"col-xs-12 col-sm-6\"><img class=banner-img ng-src=../assets/images/{{vm.img}} alt=\"\"></div><!--\n  --><div class=\"col-xs-12 col-sm-6 banner-text\"><div ng-transclude=title class=banner-title>fallback</div><div ng-transclude=body class=banner-body>fallback</div></div><div class=clearfix></div></div>");
$templateCache.put("app/components/comment/comment.html","<div class=\"comment col-sm-6 col-sm-offset-3\"><div class=\"comment__title text-center\" ng-transclude=title></div><div class=\"comment__subtitle text-center\" ng-transclude=subtitle></div><div class=\"comment__body text-center\" ng-transclude=body></div><div class=clearfix></div></div><div class=cleatfix></div>");
$templateCache.put("app/components/event/event.html","<div class=event><div class=background ng-style=\"vm.img ? {\'background\': \'url(http://vps340939.ovh.net:3001/{{vm.img}})\'} : {\'background\': \'url(assets/images/feedback3.png)\'}\"></div><div class=content><div class=date ng-transclude=date></div><div class=title ng-transclude=title></div><div class=text ng-transclude=body></div><button type=button class=more-button ng-if=vm.more ui-sref=\"singleEvent({id: vm.more})\">WIĘCEJ</button></div><div class=event__hover></div></div>");
$templateCache.put("app/components/footer/footer.html","<div class=\"container text-center\"><h1 class=products__title>BĄDŹ Z NAMI W KONTAKCIE</h1><form ng-submit=vm.subscribe.submit()><input type=email required ng-model=vm.subscribe.mail class=\"newsletter-input col-sm-8 col-sm-offset-2 col-xs-12\" placeholder=\"Wpisz e-mail by zapisać się do naszego newslettera\"><div class=clearfix></div><div ng-show=vm.subscribeSuccess style=\"color: #ff5b00; font-size: 2rem\">Dziękujemy za subskrypcję!</div><button type=submit class=newsletter-send>WYŚLIJ</button></form><div class=clearfix></div><!-- <div class=\"social-icons\">\n    <i ui-sref=\'coming\' class=\"ion-social-facebook\"></i>\n    <i ui-sref=\'coming\' class=\"ion-social-instagram-outline\"></i>\n    <i ui-sref=\'coming\' class=\"ion-social-twitter\"></i>\n    <i ui-sref=\'coming\' class=\"ion-social-youtube\"></i>\n    <i ui-sref=\'coming\' class=\"ion-social-linkedin-outline\"></i>\n  </div> --></div><div id=contact><div class=container><h1 class=contact__title>KONTAKT</h1><div class=contact__company>SELF TRAINING SP. Z O.O.<br>Nowoczesne Technologie Rozwoju</div><div class=contact__phone><a href=tel:+48-601-135-553>+48 601 135 553</a><br><a href=mailto:kontakt@winegocjacje.com>kontakt@winegocjacje.com</a></div></div><div class=\"contact__form col-sm-8 col-sm-offset-2\"><form ng-submit=vm.sendMail.submit()><input type=text name=\"\" placeholder=\"Imię i Nazwisko\" required ng-model=vm.sendMail.name><br><input type=email name=\"\" placeholder=E-mail required ng-model=vm.sendMail.mail><br><input type=text name=\"\" placeholder=Telefon ng-model=vm.sendMail.phone><br><textarea name=name rows=4 placeholder=Wiadomość required ng-model=vm.sendMail.message></textarea><div ng-show=vm.mailSuccess style=\"color: #ff5b00; font-size: 2rem\">Wiadomość została wysłana!</div><button type=submit name=button>WYŚLIJ</button></form></div><div class=clearfix></div><div class=copyright ng-click=vm.echo()>&copy; Copyright 2017 WINegocjacje</div><div class=clearfix></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav ng-if=\"vm.state.current.name != \'home\'\" class=\"navbar navbar-fixed-top navbar-inverse\" role=navigation><div class=container><div class=navbar-header><a class=navbar-brand ui-sref=home><img src=assets/images/Logo3.png> </a><button ng-click=vm.navbarToggle() type=button class=\"navbar-toggle collapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div class=\"collapse navbar-collapse\" id=bs-navbar-collapse ng-style=\"vm.collapsed ? {\'max-height\': 0, \'border-color\': \'transparent\'} : {}\"><ul class=\"nav navbar-nav navbar-center\"><li ui-sref-active=active ui-sref=home><i class=ion-ios-home></i></li><li ui-sref-active=active ui-sref=about>O NAS</li><li class=vr></li><li ui-sref-active=active ui-sref=products>PRODUKTY</li><li class=vr></li><li ui-sref-active=active ui-sref=events>AKTUALNOŚCI</li><li class=vr></li><li ui-sref-active=active ui-sref=coments>OPINIE</li><li class=vr></li><li ng-click=\"vm.scrollTo(\'contact\', 0)\">KONTAKT</li></ul><!-- <ul class=\"nav navbar-nav navbar-right navbar-social\">\n        <li ui-sref=\'coming\'>\n          <i class=\"ion-social-facebook\"></i>\n        </li>\n        <li ui-sref=\'coming\'>\n          <i class=\"ion-social-instagram-outline\"></i>\n        </li>\n        <li ui-sref=\'coming\'>\n          <i class=\"ion-social-twitter\"></i>\n        </li>\n        <li ui-sref=\'coming\'>\n          <i class=\"ion-social-youtube\"></i>\n        </li>\n        <li ui-sref=\'coming\'>\n          <i class=\"ion-social-linkedin-outline\"></i>\n        </li>\n      </ul> --></div></div></nav>");
$templateCache.put("app/components/navbarMain/navbarMain.html","<nav ng-if=\"vm.state.current.name == \'home\'\" class=\"navbar navbar-top navbar-inverse navbar-main\" role=navigation><div class=container><div class=navbar-header><a class=navbar-brand href=#><img ng-click=\"vm.scrollTo(\'main-slider\', 0)\" src=assets/images/Logo1.png> </a><button ng-click=vm.navbarToggle() type=button class=\"navbar-toggle collapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div class=\"collapse navbar-collapse\" id=bs-navbar-collapse ng-style=\"vm.collapsed ? {\'max-height\': 0, \'border-color\': \'transparent\',\'padding-bottom\': 0} : {}\"><ul class=\"nav navbar-nav navbar-center\" style=color:white><li ui-sref-active=active ui-sref=home><i class=ion-ios-home></i></li><li ui-sref-active=active ui-sref=about>O NAS</li><li class=vr></li><li ui-sref-active=active ui-sref=products>PRODUKTY</li><li class=vr></li><li ui-sref-active=active ui-sref=events>AKTUALNOŚCI</li><li class=vr></li><li ui-sref-active=active ui-sref=coments>OPINIE</li><li class=vr></li><li ng-click=\"vm.scrollTo(\'contact\', 0)\">KONTAKT</li></ul><!-- <ul class=\"nav navbar-nav navbar-right navbar-social\">\n        <li>\n          <i class=\"ion-social-facebook\"></i>\n        </li>\n        <li>\n          <i class=\"ion-social-instagram-outline\"></i>\n        </li>\n        <li>\n          <i class=\"ion-social-twitter\"></i>\n        </li>\n        <li>\n          <i class=\"ion-social-youtube\"></i>\n        </li>\n        <li>\n          <i class=\"ion-social-linkedin-outline\"></i>\n        </li>\n      </ul> --></div></div></nav>");
$templateCache.put("app/components/panel-collapse/panel-collapse.html","<div class=\"panel-collapse panel-collapsed\" ng-class=\"{\'panel-collapsed\' : !vm.opened, \'first\' : vm.borderTop}\"><div class=panel-collapse__title ng-click=\"vm.opened = !vm.opened\"><span ng-transclude=title></span> <img src=../assets/images/arrow.png></div><div class=panel-collapse__content ng-transclude=body></div></div>");}]);